import { reduxRequest } from "../../../../common/utils/reduxRequest";
import { makeFilterString } from "../../utils/Helper";
import {
  BookingsLoading,
  GetBookingDetailsSuccess,
  GetBookingsSuccess,
} from "./Action";

export const getBookingsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: BookingsLoading,
    loadingType: "list",
    successFunction: GetBookingsSuccess,
    url: `/admin/events/bookings${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getBookingDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: BookingsLoading,
    loadingType: "details",
    successFunction: GetBookingDetailsSuccess,
    action: variables?.action,
    url: `/admin/events/bookings/${variables?.id}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updateBookingStatusRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: BookingsLoading,
    loadingType: "update-status",
    action: variables?.action,
    url: `/admin/events/bookings/${variables?.id}/status`,
    method: "put",
    data: variables?.body,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
